<div class="mainStarted">
  <div class="step-1">
    <div class="main">
      <div class="main-title">
        <h1>{{ "title.main2" | translate }}</h1>
        <p>{{ "title.secondary2" | translate }}</p>
      </div>
      <div class="title-footer">
        <div class="app">
          <div class="googlePay">
            <a href="https://play.google.com/store/apps/details?id=com.kinomap.training&hl=fr&gl=US"><img
                src="assets/images/google_store.png" alt="{{ 'app.appStore' | translate }}" /></a>
          </div>
          <div class="appStore">
            <a href="https://apps.apple.com/fr/app/kinomap/id611177969"><img src="assets/images/app_store.png"
                alt="{{ 'app.playStore' | translate }}" /></a>
          </div>
        </div>
        <div class="notAccess">
          <a href="https://dl.kinomap.com/android/training/kinomap.apk">{{
            "getstarted.app.info" | translate
            }}</a>
        </div>
        <div class="trialGroup">
          <div class="party">
            <img class="party-text" src="assets/images/svg/emoticonParty.svg" alt="party" />
          </div>
          <div class="trial">
            <h5 class="trial-img">
              {{ "login.trial1" | translate }}
              <span class="and">{{ "login.trial1-and" | translate }}</span>
            </h5>
          </div>
        </div>
      </div>
      <div class="device"></div>
    </div>
    <div class="carousel">
      <div class="carousel-inner">
        <owl-carousel-o [options]="customOptions" class="items">
          <ng-container *ngFor="let slide of tabOfCarouselPartners; let i = index">
            <ng-template carouselSlide [id]="slide">
              <img class="item" [src]="'https://static.kinomap.com/manufacturer/' + slide + '.png'" [alt]="slide" />
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>
  </div>

  <hr class="step1-hr" />

  <div class="step-2">
    <app-how-to-train style="width: 100%" [data]="sport"></app-how-to-train>
  </div>

  <div class="step-3 container-fluid">
    <div class="start-title">
      <h2 class="text-center">{{ "start.title" | translate }}</h2>
    </div>
    <div class="start-mode">
      <div class="start-card" *ngFor="let card of mode | slice: 0:6">
        <div class="drawing">
          <div class="drawing-medium">
            <img class="medium" src="{{ card.mediumImage }}" alt="{{ card.title }}" />
          </div>
          <div class="drawing-small-mid">
            <img style="max-width: 156px;" class="small" src="{{ card.smallImage1 }}" alt="{{ card.title }}" />
            <img style="max-width: 156px;" class="small" src="{{ card.smallImage2 }}" alt="{{ card.title }}" />
          </div>
        </div>
        <div class="mode-explain">
          <h5>{{ card.title | translate }}</h5>
          <span> {{ card.span | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="step-4">
    <app-carousel-features style="width: 100%" [data]="features" type="images" title="homepage.step4.title"
      subTitle="homepage.step4.subTitle"></app-carousel-features>
  </div>

  <div>

    <div class="step-6">
      <div class="rate">
        <div class="rate-title">
          <h2>{{ "subscription.title" | translate }}</h2>
          <aside>{{ "subscription.secondary" | translate }}</aside>
        </div>
        <app-step-six />
      </div>


    </div>

  </div>

  <div class="step-7 container-fluid">
    <app-carr2-img [data]="remark"></app-carr2-img>
  </div>

  <div class="step-8">
    <app-faq></app-faq>
  </div>
</div>